
















































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SelectOption, SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import * as countries from './countryDropdown.json';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import QrcodeVue from 'qrcode.vue';
import SwPwInput from './sw-pw-input.vue';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { InfoState } from '@/core';

const cssPrefix = 'two-factor-auth';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwToggle,
    QrcodeVue,
    SwPwInput,
    SwIcon,
  },
  directives: {
    tooltip,
  },
})
export default class TwoFactorAuth extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  displayTfa : any;
  @Prop({ required : true })
  tfaDialogData : any;
  isSubmitted : boolean = false;
  twoFactorAuthSecret = '';
  generatedSecretId = '';
  generatedSecretIdDisplay = '';
  tfaAuthCode = '';
  sendTFAsms = '';
  personalPhoneNumber = '';
  companyPhoneNumber = '';
  countryList: any = [];
  countryCode: any = '';
  selectedCountry: any = '';
  joinedPhoneNumber: any = '';
  isPhoneValid: any = '';
  selectedTwoFactorOption: any = {};
  selectedTwoFactorOptionId : string = '';
  tempModeId: any = '';
  lockDropdown = false;
  twoFactorOptions: SelectOption[] = [];
  showVerifyButton: boolean = true;
  lockPhoneInput: boolean = false;
  hideCountryDropdown: boolean = true;
  isTFAChecked = true;
  showQR : boolean = true;
  displaySecretCode: boolean = false;
  appCode: any = '';
  phoneTooltipText: string = `${this.$t('twoFactorAuth.phoneToolltipText-1')
  .toString()} ${this.$t('twoFactorAuth.phoneToolltipText-2')
  .toString()}`;
  showCountryDropdown : boolean = false;
  isSmsSuccess: boolean = false;
  smsCode: any = '';
  showButtons: boolean = false;
  codeType: any = 'password';

  created() {
    this.countryList = countries.default;
    this.tempModeId = this.tfaDialogData.mode;
    this.twoFactorAuthSecret = this.tfaDialogData.twoFactorAuthSecret;
    this.generatedSecretId = this.tfaDialogData.generatedSecretId;
    this.generatedSecretIdDisplay = this.tfaDialogData.generatedSecretIdDisplay;
    this.tfaAuthCode = this.tfaDialogData.tfaAuthCode;
    this.sendTFAsms = this.tfaDialogData.sendTFAsms;
    this.personalPhoneNumber = this.tfaDialogData.personalPhoneNumber;
    this.companyPhoneNumber = this.tfaDialogData.companyPhoneNumber;
    this.twoFactorOptions = this.decideTwoFactorOptions(this.tfaDialogData.isAllowTFAOff);
    if (this.sendTFAsms === 'YES') {
      this.setNumberSettings();
      console.warn(this.selectedCountry);
      this.joinedPhoneNumber = this.selectedCountry.number + this.personalPhoneNumber;
      const isValid = /^\+[1-9]\d{10,14}$/.test(this.joinedPhoneNumber);

      // const isValid = /^\+[1-9]\d{10,14}$/.test(this.personalPhoneNumber);

      if (isValid) {
        this.isPhoneValid = 'Valid';
      } else {
        this.isPhoneValid = 'Invalid';
      }
    }
    if (this.tfaDialogData.showOnlyApp) {
      this.lockDropdown = true;
      this.selectedTwoFactorOption = this.twoFactorOptions[1];
      this.selectedTwoFactorOptionId = this.selectedTwoFactorOption.id;
    } else if (this.tfaDialogData.isPhone) {
      this.lockDropdown = true;
      this.showVerifyButton = false;
      this.lockPhoneInput = true;
      this.hideCountryDropdown = false;

      this.twoFactorOptions.push({ id : 'SMS', value: 'SMS', label: 'SMS' });

      const countryCode = this.tfaDialogData.phoneNumber.slice(0, -10);
      const originalNumber = this.tfaDialogData.phoneNumber.substr(this.tfaDialogData.phoneNumber.length - 10);

      this.personalPhoneNumber = countryCode + originalNumber;

      this.selectedTwoFactorOption = this.twoFactorOptions[2];
      this.selectedTwoFactorOptionId = this.selectedTwoFactorOption.id;
    } else {
      if (this.$route.path.includes('org-profile')) {
        this.twoFactorOptions?.map((ele: any) => {
          if (ele?.id?.toLowerCase() === this.tfaDialogData?.mode?.toLowerCase()) {
            this.selectedTwoFactorOptionId = ele?.id || '';
            this.selectedTwoFactorOption = ele || {};
          } else {
            this.selectedTwoFactorOption = this.twoFactorOptions[0] || {};
            this.selectedTwoFactorOptionId = this.selectedTwoFactorOption?.id || '';
          }
        });
      } else {
        this.selectedTwoFactorOption = this.twoFactorOptions[0];
        this.selectedTwoFactorOptionId = this.selectedTwoFactorOption.id;
      }
    }
  }

  setNumberSettings() {
    let defaultCountry;
    const countryCode = this.personalPhoneNumber.slice(0, -10);
    const originalNumber = this.personalPhoneNumber.substr(this.personalPhoneNumber.length - 10);

    for (let i = 0; i < this.countryList.length; i += 1) {
      if (this.countryList[i].name.toLowerCase() === 'united states') {
        defaultCountry = this.countryList[i];
        break;
      }
    }

    if (this.personalPhoneNumber.length < 10) {
      this.selectedCountry = { ...defaultCountry } ;
      return;
    }

    if (this.personalPhoneNumber.includes('+')) {
      for (let i = 0; i < this.countryList.length; i += 1) {
        if (this.countryList[i].number.trim() === countryCode) {
          this.selectedCountry = { ...this.countryList[i] };
          this.personalPhoneNumber = originalNumber;
          this.countryCode = countryCode;
          break;
        }
        this.selectedCountry = { ...defaultCountry };
        this.personalPhoneNumber = originalNumber;
        this.countryCode = countryCode;
      }
    } else {
      this.selectedCountry = { ...defaultCountry };
    }
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    this.isSubmitted = true;
    if (this.isValidate()) {
    }
  }
  isValidate() {
    const validateFlag = true;
    return validateFlag;
  }
  decideTwoFactorOptions(isAllowTFAOff: boolean) {
    const options = [
      { id: 'Email', label : this.$t('signup.emailotp') as string, name : this.$t('signup.emailotp') as string },
      { id: 'App', label : this.$t('signup.authapp') as string, name : this.$t('signup.emailotp') as string },
      { id: 'SMS', label : this.$t('twoFactorAuth.smsMode') as string, name : this.$t('twoFactorAuth.smsMode') as string },
    ];
    if (isAllowTFAOff) {
      options.unshift({ id: 'Off', label : this.$t('common.off') as string, name : this.$t('common.off') as string });
    }
    if (this.sendTFAsms !== 'YES') {
      options.pop();
    }
    return options;
  }
  unCheckTfa() {
    this.isTFAChecked = false;
    const tfa = {
      tfaMode: 'OFF',
      tfaAuthCode: '',
    };
    this.$emit('send-data', tfa);
  }
  on2FASelect() {
    this.selectedTwoFactorOption  = this.twoFactorOptions.filter((ele : any) => ele.id === this.selectedTwoFactorOptionId)[0];
  }
  setSecretCode() {
    this.displaySecretCode = true;
  }
  // tslint:disable-next-line:no-unused
  validateKey(val : any) {
    console.warn(this.appCode);
  }
  onCountryChange(val : any) {
    this.countryCode = val;

    for (let i = 0; i < countries.default.length; i += 1) {
      if (countries.default[i].number.trim() === val) {
        this.selectedCountry = { ...countries.default[i] };
        break;
      }
    }

    this.joinedPhoneNumber = this.selectedCountry.number + this.personalPhoneNumber;

    if (val === '') {
      this.countryList = countries.default;
    } else {
      this.countryList = countries.default.filter((country : any) => country.number.trim()
      .includes(val.trim()));
    }
  }
  countrySelected(country : any) {
    this.selectedCountry = { ...country };
    console.warn(this.selectedCountry);
    console.warn(this.countryCode);
  }
  hideDropDownAfterSec() {
    setTimeout(() => {
      this.showCountryDropdown  = false;
    },         600);
  }
  loadCountryDropDownData() {
    this.countryList = countries.default.filter((country : any) => country.number.trim()
      .includes(this.selectedCountry.number.trim()));
    this.showCountryDropdown = true;
  }
  personalPhoneNumberChanged(val: any) {
    this.personalPhoneNumber =  val;
    this.joinedPhoneNumber = this.selectedCountry.number + val;
    this.isPhoneValid = this.isNumberValid(this.joinedPhoneNumber);
  }
  isNumberValid(val : any) {
    const isValid = /^\+[1-9]\d{10,14}$/.test(val);
    if (isValid) {
      return 'Valid';
    }
    return 'Invalid';
  }
  updateTFAPref(val : any = '') {
    if (this.smsCode.length === 0 && this.isSmsSuccess && val === '') {
      const message : InfoState = { infoType : 'failed' , infoMsg : 'Please Enter Verification Code' };
      this.$store.commit('enqueueMessage' ,  message);
      return;
    }

    if (val === 'resend') {
      this.smsCode = '';
    }
    const body = {
      tfaMode: 'PHONE',
      tfaAuthCode: this.smsCode,
      phoneNumber: this.joinedPhoneNumber,
    };

    const valid = this.isNumberValid(this.joinedPhoneNumber);

    if (valid.toLowerCase() === 'valid') {
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/setTFAPreference', body)
      .then((resp : any) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          const message : InfoState = { infoType : 'success' , infoMsg : resp.msgDesc };
          this.$store.commit('enqueueMessage' ,  message);
          if (this.isSmsSuccess) {
            if (val === '') {
              this.isSmsSuccess = false;
              this.showButtons = false;
              this.$emit('send-data', { code: 'PHONE' });
            }
          } else {
            this.isSmsSuccess = true;
            this.showButtons = true;
          }
        } else {
          const message : InfoState = { infoType : 'failed' , infoMsg : resp.msgDesc };
          this.$store.commit('enqueueMessage' ,  message);
        }
        this.$store.commit('stopLoading');
      });
    } else {
      const message : InfoState = { infoType : 'failed' , infoMsg : 'Phone Number Invalid' };
      this.$store.commit('enqueueMessage' ,  message);
    }
  }
  setTFA() {
    if (this.$route.path.includes('org-profile') && (this.tempModeId.toLowerCase() === this.selectedTwoFactorOptionId.toLowerCase())) {
      this.closeDialog();
      return;
    }
    if (this.isSmsSuccess) {
      this.updateTFAPref();
      return;
    }
    if (this.selectedTwoFactorOption.id === 'App' && this.isTFAChecked) {
      this.activateApp();
      return;
    }
    if (this.isTFAChecked) {
      if (this.selectedTwoFactorOption.id === 'Email') {
        this.tfaAuthCode = '';
      }
      const tfa = {
        tfaMode: this.selectedTwoFactorOption.id,
        tfaAuthCode: this.tfaAuthCode,
        secretId: this.generatedSecretIdDisplay,
      };
    //   this.dialogRef.close(tfa)
      this.$emit('send-data', tfa);
    } else {
      console.warn('in else part');
      const tfa = {
        tfaMode: 'OFF',
        tfaAuthCode: '',
      };
    //   this.dialogRef.close(tfa)
      this.$emit('send-data', tfa);
    }
  }
  showCode(val : any) {
    val === 'show' ? this.codeType = 'text' : this.codeType = 'password';
  }
  handleEdit() {
    this.isSmsSuccess = false;
    this.smsCode = '';
  }
  activateApp() {
    if (this.appCode === '') {
      const message : InfoState = { infoType : 'failed' , infoMsg : 'Please enter the verification code generated in the authenticator app to proceed.' };
      this.$store.commit('enqueueMessage' ,  message);
      return;
    }
    const params = {
      twofactorAuthMode: this.selectedTwoFactorOption.id.toUpperCase(),
        // userlogin: JSON.parse(localStorage.getItem('currentUser')).email,
      userlogin: this.$store.getters.getSandboxUserId,
      phoneNo: '',
      captchaText: '',
      twofactorKeyCode: this.tfaAuthCode,
      TFACode: this.appCode,
    };
    this.$store.dispatch('SnbProfileStoreModule/verifyTFA', params)
      .then((resp : any) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          const message : InfoState = { infoType : 'success' , infoMsg : resp.msgDesc ? resp.msgDesc : 'Activated Successfully' };
          this.$store.commit('enqueueMessage' ,  message);
          const request = {
            code: 'APP',
            verified: true ,
            tfaMode: this.selectedTwoFactorOption.id.toUpperCase(),
            tfaAuthCode: this.tfaAuthCode,
          };
          this.$emit('send-data', request);
        } else {
          const message : InfoState = { infoType : 'failed' , infoMsg : resp.msgDesc ? resp.msgDesc : 'Something went wrong' };
          this.$store.commit('enqueueMessage' ,  message);
          return;
        }
      });
  }
}
